export function getItem(key: string): string | null {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

export function setItem(key: string, value: string) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
        return null;
    }
}
